// @flow
import React, { type Node } from 'react';
import { Link } from 'react-router';
import { Trans } from 'react-i18next';

import ConfirmationDialog from 'app/common/components/Confirmation/ConfirmationDialog';

import enhanceToPay from './enhanceToPay';
import styles from './Nope.scss';


type CProps = {
  handlePay: (e: SyntheticEvent<HTMLElement>) => void,
  t: (s: string) => string,
  children: Node,
}

const Confirm = ({ handlePay, children, t }: CProps) => (
  <ConfirmationDialog
    onConfirm={handlePay}
    text={t('subs:confirm_pay')}
    confirmButtonText={t('subs:confirm_pay_bt')}
  >
    {handleConfirm =>
      <a href="pay" onClick={handleConfirm}>{children}</a>}
  </ConfirmationDialog>
);

type Props = {
  service?: string,
  handlePay: (e: SyntheticEvent<HTMLElement>) => void,
  t: (s: string) => string,
};

const ToPay = ({ service, handlePay, t }: Props) => (
  <div>
    <div className={styles.text}>
      <Trans i18nKey="subs:not_paid">
        {'Не оплачена подписка на тариф.'}
      </Trans>
      <br />
      {service
        ? <Trans i18nKey="subs:not_paid_todo">
          {'Вернитесь '}
          <Link to="/apps">назад к приложениям</Link>
          {' или '}
          <Confirm handlePay={handlePay} t={t}>оплатите подписку</Confirm>
          {'.'}
        </Trans>
        : <Trans i18nKey="subs:not_paid_todo_no_service">
          {'Вернитесь '}
          <Link to="/apps">назад к приложениям</Link>
          {'.'}
        </Trans>}
    </div>
  </div>
);

export default enhanceToPay(ToPay);
